import { HttpClient } from './http-client';
import { Observable } from 'rxjs';

export class ProfileService extends HttpClient {
  changeEmail(
    new_email: string,
    new_email_confirmation: string
  ): Observable<void> {
    return this.post(`/api/profile/change-email`, {
      new_email,
      new_email_confirmation,
    });
  }

  changePassword(
    password: string,
    new_password: string,
    new_password_confirmation: string
  ): Observable<void> {
    return this.post(`/api/profile/change-password`, {
      password,
      new_password,
      new_password_confirmation,
    });
  }

  changePhone(new_phone: string): Observable<void> {
    return this.post(`/api/profile/change-phone`, {
      new_phone,
    });
  }
}
